import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false); // for dropdown

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Meditation", path: "/meditation" },
    { name: "Chakras", path: "/chakras" },
    { name: "Benefits", path: "/benefits" },
    { name: "Contact", path: "/contact" },
    { name: "Donation", path: "/donate" },
  ];

  return (
    <>
      <div className="bg-gradient-to-r from-green-100 to-indigo-100 py-2 px-2 text-center">
        <h2 className="text-xl md:text-xl font-semibold text-gray-700">
          SHREE NIRMALA SAHAJA YOGA CHARITABLE TRUST
        </h2>
      </div>

      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.jpg" alt="Shree Nirmala Logo" className="h-10 w-auto" />
            <span className="text-2xl font-bold text-green-700 tracking-wide hidden md:inline">
              Shree<span className="text-indigo-600">Nirmala</span>
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="space-x-6 hidden md:flex items-center">
            {/* Dropdown - About */}
            <div className="relative">
  <button
    onClick={() => setAboutOpen(!aboutOpen)}
    className="flex items-center gap-1 text-gray-700 hover:text-green-700 font-medium focus:outline-none"
  >
    About <FaChevronDown className={`text-xs transition-transform ${aboutOpen ? "rotate-180" : ""}`} />
  </button>
  {aboutOpen && (
    <div className="absolute top-full left-0 mt-2 bg-white border rounded shadow-md w-48 z-10">
      <Link
        to="/shrimataji"
        onClick={() => setAboutOpen(false)}
        className={`block px-4 py-2 text-sm hover:bg-green-50 ${
          location.pathname === "/shrimataji" ? "text-green-700 font-medium" : "text-gray-700"
        }`}
      >
        Shri Mataji
      </Link>
      <Link
        to="/about"
        onClick={() => setAboutOpen(false)}
        className={`block px-4 py-2 text-sm hover:bg-green-50 ${
          location.pathname === "/about" ? "text-green-700 font-medium" : "text-gray-700"
        }`}
      >
        Foundation
      </Link>
    </div>
  )}
</div>


            {/* Other Links */}
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-gray-700 hover:text-green-700 transition font-medium ${
                  location.pathname === item.path ? "text-green-700 underline underline-offset-4" : ""
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FiX className="text-2xl text-green-800" /> : <FiMenu className="text-2xl text-green-800" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white px-6 pb-4 shadow-md space-y-2">
            {/* Dropdown toggle manually on mobile */}
            <div>
              <button
                onClick={() => setAboutOpen(!aboutOpen)}
                className="block w-full text-left text-gray-700 font-medium py-2"
              >
                About {aboutOpen ? "▲" : "▼"}
              </button>
              {aboutOpen && (
                <div className="pl-4 space-y-1">
                 <Link to="/shrimataji" onClick={() => setMenuOpen(false)} className="block text-gray-600 py-1">
                    Shri Mataji
                  </Link>
                  <Link to="/about" onClick={() => setMenuOpen(false)} className="block text-gray-600 py-1">
                    Trust Overview
                  </Link>
                 
                </div>
              )}
            </div>

            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`block text-gray-700 font-medium py-2 border-b ${
                  location.pathname === item.path ? "text-green-700 underline underline-offset-4" : ""
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
